import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { getApiBaseUrl } from "./apiClient";

const DebugContext = createContext({ serverDebug: false });

export function DebugProvider({ children }) {
  const [serverDebug, setServerDebug] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const base = getApiBaseUrl();
        const r = await fetch(`${base}/health`);
        const j = await r.json();
        if (!cancelled && typeof j.debug === "boolean") {
          setServerDebug(j.debug);
        }
      } catch {
        if (!cancelled) {
          setServerDebug(
            String(process.env.REACT_APP_DEBUG_MODE || "")
              .toLowerCase()
              .trim() === "true",
          );
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const value = useMemo(() => ({ serverDebug }), [serverDebug]);
  return (
    <DebugContext.Provider value={value}>{children}</DebugContext.Provider>
  );
}

export function useServerDebug() {
  return useContext(DebugContext).serverDebug;
}
